import { useState } from 'react';
import ErrImg from '../../assetes/icons/errorInApp.svg'
import { useNavigate } from 'react-router-dom';

function CommonError ({ error, resetErrorBoundary }) {

  console.log('Error boundary: ', error)
  const [triedOnce, setTriedOnce] = useState(false)

  const navigate = useNavigate()

  const handleGoBack = () => {
    if (!triedOnce) setTriedOnce(true)

    if (window.location.pathname === '/dashboard') {
      window.location.reload();
    } else {
      navigate('/dashboard', { replace: true })
      // resetErrorBoundary()
    }
  };

  return (
    <div className="p-3 h-auto">
      <section className='grid place-items-center'>
        <div className='p-8 border border-black rounded-lg flex flex-col justify-center items-center w-[80vw] sm:max-md:w-[70vw] md:max-lg:w-[70vw] lg:w-[50vw]'>
          <img src={ErrImg} className="w-[20vw]" />
          <div className=''>
            <div className='mb-2 md:mb-4 font-bold text-red-700 tracking-wide text-[6vw] sm:max-md:text-[4.8vw] md:max-lg:text-[4.5vw] lg:text-[3.5vw] leading-[8vw] sm:leading-[5vw]'>Some error occured.</div>
            <div className='font-semibold text-blue-900 text-[3.1vw] sm:max-md:text-[2.8vw] md:max-lg:text-[2.5vw] lg:text-[2vw] leading-[3vw] sm:leading-[2.5vw]'>Please reach out to our technical team for resolution</div>
            <span>
            {/* {
              error?.message && <>
              {
                JSON.stringify(error.message, null, '\t')
              }
              </>
            } */}
            </span>
            <div className='mt-5 cursor-pointer underline text-blue-500 text-[2.7vw] sm:max-md:text-[2.5vw] md:max-lg:text-[2.2vw] lg:text-[1.8vw]'
              onClick={handleGoBack}
            >
              Go to homepage
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CommonError;